module.exports = __webpack_public_path__ + "img/image1.3e381b5f.png";